import {PaymentConstant} from "../constant";


export const fetchPaymentHistory = (props: any) => {
    return {type: PaymentConstant.FETCH_PAYMENT_HISTORY, payload: props};
}

